var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToggleList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18403 8.95139H2.69097M9.18403 6.59028H2.69097M0.625 4.22917H11.25M3.45833 0.6875H8.41667C9.40843 0.6875 9.90431 0.6875 10.2831 0.880509C10.6163 1.05029 10.8872 1.32119 11.057 1.65439C11.25 2.03319 11.25 2.52907 11.25 3.52083V8.47917C11.25 9.47093 11.25 9.96681 11.057 10.3456C10.8872 10.6788 10.6163 10.9497 10.2831 11.1195C9.90431 11.3125 9.40843 11.3125 8.41667 11.3125H3.45833C2.46657 11.3125 1.97069 11.3125 1.59189 11.1195C1.25869 10.9497 0.987785 10.6788 0.818009 10.3456C0.625 9.96681 0.625 9.47093 0.625 8.47917V3.52083C0.625 2.52907 0.625 2.03319 0.818009 1.65439C0.987785 1.32119 1.25869 1.05029 1.59189 0.880509C1.97069 0.6875 2.46657 0.6875 3.45833 0.6875Z",
    stroke: "#FCFCFD",
    strokeWidth: 1.19248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleList);
export default __webpack_public_path__ + "static/media/icon-toggle-list.59b6f543e252a66fa3760fd1b8a2e5286345eeb8dc58f81451e59692e321deb9.svg";
export { ForwardRef as ReactComponent };